<template>
  <div>
    <PlanEnded v-if="planEnded" />
    <div v-else class="boxes light purple">
      <template v-if="!isFollowupPlan">
      <Box :title="list.display_name" :thumb="list.thumbnail" :link="'/plan/bonus/videos/'+list.name" v-for="(list, index) in lists" :key="index">
        <p>{{list.display_content}}</p>
      </Box>
      </template>
      <Box :title="t('Recipes Booklet')" :thumb="RecipesIcon" link="/plan/bonus/recipes">{{t("Special recipes for the plan")}}</Box>
      <Box :title="t('Recipes Book')" :thumb="RecipesIcon" link="/plan/bonus/recipes-new">{{t("Additional recipes")}}</Box>
      <Box :title="t('Discount for supplements')" v-if="daysInPlan >= 1" :thumb="DiscountIcon" link="/plan/bonus/coupon-code" />
    </div>
  </div>
</template>

<script>

import t from '@/lib/Locale';
import Box from "@/components/ui/widgets/Box";
import ArrowRightIcon from '@/assets/icons/arrow-right.svg';
import ExclusivesIcon from '@/assets/icons/menu/exclusives.svg';
import PeriodIcon from '@/assets/icons/menu/woman.svg';
import RecipesIcon from '@/assets/icons/menu/recipes.svg';
import FastingIcon from '@/assets/icons/menu/yoga.svg';
import DiscountIcon from "@/assets/icons/discount-icon.png";

import Fito from "@/lib/fito";
import PlanEnded from "@/components/ui/plan/PlanEnded.vue";
import {isInPlan, isInPlanOrTrainerMode, Plan_followup, Plan_trainers} from "@/lib/PlanUtils";

const TotalPlanDays = 100;

export default {
  name: "BonusHome",
  props: ["meta"],
  components: {PlanEnded, Box},
  data() {
    return {
      ArrowRightIcon, ExclusivesIcon, RecipesIcon, PeriodIcon, FastingIcon, DiscountIcon,
      lists: [],
      daysInPlan: 0,

      planEnded: false,
      isFollowupPlan: false,
    }
  },

  async mounted() {
    const login = await Fito().Login.safeCheckLogin()
    if (!login) return this.$router.push('/plan/login')

    this.isFollowupPlan = isInPlanOrTrainerMode(login, [Plan_followup], 'followup')
    this.planEnded = login.daysInPlan > TotalPlanDays && !isInPlan(login, [Plan_followup, Plan_trainers])

    const mediaLists = await Fito().Plan.getMediaLists()
    const lists = mediaLists.sort((a,b) => a.sort < b.sort ? -1:1).filter(l => l.folder === 'bonus')
    if (lists.length > 0) {
      this.lists = lists;
    }

    // remove bonus-conscious-eating if day is < 15
    if (login.daysInPlan) {
      this.daysInPlan = login.daysInPlan
      if (login.daysInPlan < 15) {
        this.lists = this.lists.filter(l => l.name !== 'bonus-nightly-eating')
      }
    }

  },

  methods : {
    t,
  },

  watch : {
  }

}
</script>
